import React from 'react';

const IfConcrete = ({ children, product }) => {
  return product?.type === 'CONCRETE' ? children : null;
};

export default IfConcrete;
